import type {CSSProperties} from 'react';
import {T} from '@territory/tokens';
import {radius, space} from '../scale.js';

export const WEDGE_BV2_WHO_LOOKS = ['bv2who-person-closed-local-active', 'bv2who-person-closed-local-passive', 'bv2who-person-closed-corporate-active', 'bv2who-person-closed-corporate-passive', 'bv2who-person-open-local-active', 'bv2who-person-open-local-passive', 'bv2who-person-open-corporate-active', 'bv2who-person-open-corporate-passive', 'bv2who-contact-button', 'bv2who-contact-link'] as const;
export type WedgeBv2WhoLook = typeof WEDGE_BV2_WHO_LOOKS[number];
const looks = new Set<string>(WEDGE_BV2_WHO_LOOKS);
export const isWedgeBv2WhoLook = (look: string): look is WedgeBv2WhoLook => looks.has(look);
const role = (name: string, fallback: string) => `var(--wedge-bv2-${name}, ${fallback})`;

/* Preserve the released brief Who shells. The wrapping contacts have no expanded target. */
export function wedgeBv2WhoStyle(look: WedgeBv2WhoLook): CSSProperties {
  if (look === 'bv2who-contact-button' || look === 'bv2who-contact-link') {
    return {
      display: 'inline-flex', alignItems: 'center', gap: space[2], minHeight: 36,
      padding: '7px 12px', borderRadius: radius.lg, border: `1px solid ${role('line', T.separator)}`,
      background: role('card2', T.surfaceAlt), color: role('text', T.label), textDecoration: 'none', maxWidth: '100%',
      ...(look === 'bv2who-contact-button' ? {font: 'inherit', textAlign: 'left', cursor: 'pointer'} : {}),
    };
  }
  const open = look.includes('-open-');
  return {
    width: '100%', textAlign: 'left', font: 'inherit', color: 'inherit', cursor: look.endsWith('-active') ? 'pointer' : 'default',
    padding: space[3], borderRadius: radius.xl, background: open ? 'transparent' : role('card2', T.surfaceAlt),
    border: open ? `1.5px dashed ${role('line2', T.separator)}` : `1px solid ${role('line', T.separator)}`,
    opacity: look.includes('-corporate-') ? 0.82 : 1, display: 'flex', flexDirection: 'column', gap: radius.md,
  };
}
